<template>
    <div class="main-bd mg20">
        <div class="section-wrapper">
            <div class="section-main22">
                <!-- <div class="order-section" > -->
                <div class="order-number order-number1">
                    <h3>{{customer.name}} <el-button v-if="Acs('/customers/update') && !customer.pid" type="primary" size="mini" @click="handleUpdate">编辑客户</el-button></h3>
                  <span>业务员：{{customer.username}}</span>
                  <el-button v-if="customer.username" type="primary" size="mini" @click="unboundUpdate(customer)">解绑</el-button>
                  <el-button v-if="!customer.username && !customer.pid" type="success" size="mini" @click="bindingUpdate(customer)">领取客户</el-button>
                </div>

                <div class="roder-number">
                    <!--<el-button type="primary" size="small" plain @click="handleUpdate">编辑客户</el-button>-->
                </div>
                <!-- </div> -->
            </div>
            <el-tabs v-if="customer.id" v-model="activeName" @tab-click="handleSwitch" class="order-tab">
                <el-tab-pane label="客户资料" name="Detail">
                    <workspace v-if="activeTab == 'Detail' && customer.id" :customer="customer" :customer-id="parseInt(customer.id)" :isEdit="!customer.pid || Acs('/customers/edit-child')"></workspace>
                </el-tab-pane>
<!--                <el-tab-pane v-if="Acs('/contacts/index') || Acs('/contacts/my-index')" label="联系人" name="Contacts">-->
<!--                    <customer-contacts v-if="activeTab=='Contacts'" :customer-id="parseInt(customerId)"-->
<!--                    :customerName="customer.name"></customer-contacts>-->
<!--                </el-tab-pane>-->
<!--                <el-tab-pane label="跟进记录" name="Traces" v-if="Acs('/customer/traces/index')" >-->
<!--                    <customer-traces v-if="activeTab == 'Traces'" :customer-id="parseInt(customerId)"></customer-traces>-->
<!--                </el-tab-pane>-->
                <el-tab-pane label="回访记录" name="Visits" v-if="Acs('/customer/visits/index')" >
                    <customer-visits v-if="activeTab == 'Visits'" :customer-id="parseInt(customerId)"></customer-visits>
                </el-tab-pane>
                <el-tab-pane label="成交订单" name="Orders">
                    <customer-orders v-if="activeTab == 'Orders' && customer.id"
                        :customerId="parseInt(customer.id)"
                        :isEdit="!customer.pid || Acs('/customers/edit-child')"
                        :customerName="customer.name"></customer-orders>
                </el-tab-pane>
                <el-tab-pane label="回款记录" name="PaymentLogs" v-if="Acs('/order/pay')" >
                    <customer-payment-logs v-if="activeTab == 'PaymentLogs'"></customer-payment-logs>
                </el-tab-pane>
                <el-tab-pane label="账号管理" name="Accounts" v-if="Acs('/customer/accounts/index')">
                    <customer-account v-if="activeTab == 'Accounts' && customer.id" :customer="customer" @refresh="refresh"></customer-account>
                </el-tab-pane>
                <el-tab-pane label="产品信息" name="product" v-if="Acs('/customer/accounts/index')">
                    <customer-products v-if="activeTab == 'product'"
                                       :customer-id="parseInt(customerId)" 
                                       :isEdit="!customer.pid || Acs('/customers/edit-child')"></customer-products>
                </el-tab-pane>
                <el-tab-pane label="报价记录" name="quote" v-if="Acs('/customer-quote/index')">
                    <customer-quote v-if="activeTab == 'quote'" :customer="customer"></customer-quote>
                </el-tab-pane>
                <el-tab-pane v-if="Acs('/customer/change-logs/index')" label="操作记录" name="ChangeLogs">
                    <el-tabs class="order-tab"  style="float: left;width:100%">
                        <el-tab-pane  v-if="Acs('/customer/change-logs/index')"  label="记录汇总">
                            <customer-change-logs v-if="activeTab == 'ChangeLogs'" :customer-id="parseInt(customerId)"></customer-change-logs>
                        </el-tab-pane>
                        <el-tab-pane    label="解绑/绑定记录">
                            <customer-bind-logs  :customer-id="parseInt(customerId)"></customer-bind-logs>
                        </el-tab-pane>
                        <el-tab-pane label="流转记录">
                            <CustomerTransitLogs :customer-id="parseInt(customerId)"></CustomerTransitLogs>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="断续记录" name="disruption" v-if="customer.id">
                    <customer-disruption v-if="activeTab == 'disruption'" :customer-id="parseInt(customerId)"></customer-disruption>
                </el-tab-pane>
            </el-tabs>


        </div>

    </div>
</template>
<script>
    import CustomerService from "~/services/customer";
    import CustomerTraces from "./Traces.vue";
    import CustomerVisits from "./Visits.vue";
    import CustomerContacts from "./Contacts.vue";
    import CustomerOrders from "./Orders.vue";
    import CustomerPaymentLogs from "./PaymentLogs.vue";
    import CustomerAccount from "./Account.vue";
    import CustomerProducts from "./products.vue";
    import CustomerChangeLogs from "./ChangeLogs.vue";
    import CustomerBindLogs from "./BindLogs.vue";
    import Workspace from "./Workspace.vue";
    import MessageService from "~/services/Message";
    import CustomerDisruption from "./Disruption.vue";
    import CustomerTransitLogs from "./TransitLogs.vue";
    import CustomerQuote from "./Quote.vue";

    import moment from 'moment'
    import 'moment/locale/zh-cn'

    moment.locale('zh-cn');

    export default {
        components: {
            Workspace,
            CustomerChangeLogs,
            // 客户跟进记录子页
            CustomerTraces,
            // 客户回访记录子页
            CustomerVisits,
            // 客户联系人列表子页
            CustomerContacts,
            // 客户成交订单子页
            CustomerOrders,
            // 客户回款记录子页
            CustomerPaymentLogs,
            // 客户账号管理子页
            CustomerAccount,
            CustomerProducts,
            CustomerBindLogs,
            CustomerDisruption,
            CustomerTransitLogs,
            CustomerQuote
        },
        data() {
            return {
                customerId: 0,
                // orderId: 0,
                customer: {}, //客户资料
                activeName: 'Detail', // 默认展开的Tab
                activeTab: 'Detail',
                value: '',
                options: [],
                payments: [],  //回款记录
                // totalPlanAmount: 0, //总应付金额
                // totalActualAmount: 0  //实付总金额
                origin_name: '',         //客户来源
                type_name: '',           //客户类型
                customer_level: '',      //客户等级
                customer_maturity: '',   //客户成熟度
                customerType: {},        //客户类型
                customerLevel: {},       //客户等级
                customerMaturity: {},    //客户成熟度
                customerSource: {},       //客户来源
                //客户绑定，删除
                form: {
                  customer_ids: [],
                  user_id: '',
                },
               customers: [],
            }
        },
        filters: {
            date(val) {
                return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
            }
        },

        created: function () {
            this.current_product_config
            MessageService.readCustomerMessage(this);
            this.customerId = this.$route.query["id"];
            this.customerType = CustomerService.getTypes(true);
            this.customerLevel = CustomerService.getLevels(true);
            this.customerMaturity = CustomerService.getMaturity();
            this.customerSource = CustomerService.getSource(true);

            if(this.$route.query['tab']){
                this.activeTab = this.$route.query['tab'];
                this.activeName = this.$route.query['tab'];
            }
            if (parseInt(this.customerId) > 0) {
                this.getInfo();
            }
        },
        watch:{
            $route: function (to, from, next) {
                if(this.$route.query['tab']){
                    this.activeTab = this.$route.query['tab'];
                    this.activeName = this.$route.query['tab'];
                }
            },
        },
        methods: {

            handleSwitch(tab, event) {
                if(tab.name=='Detail'){
                    this.getInfo();
                }
                /**
                 *@desc 为啥这里这么做，每个tab切换只需带上id,也就是所谓的customerid,不然切换其他标签页分页处理会出现意想不到的错误
                 */
                let data = {path: "", query: {}};
                data.path = this.$route.path;
                data.query["id"] = this.$route.query['id'];
                data.query["tab"] = tab.name;
                this.$router.push(data);
                this.activeTab = tab.name;
            },

            getInfo() {
                CustomerService.getInfo(this.customerId).then(res => {
                    if (res && res.code == 0) {
                        this.customer = res.data;
                        this.origin_name = this.customerSource[this.customer.origin];
                        this.type_name = this.customerType[this.customer.type];
                        this.customer_level = this.customerLevel[this.customer.level];
                        this.customer_maturity = this.customerMaturity[this.customer.maturity];
                        document.title = this.customer.name;
                    }
                }).catch(err => {
                    console.error(err)
                });
            },

            handleUpdate() {
                this.$router.push({
                    path: "/customers/update",
                    query: {
                        id: this.$route.query['id'],
                    }
                });
            },

            unboundUpdate(customer) {
              this.$confirm("您确定要解绑该客户吗？解绑后，客户将会进入客户公海池被其他人绑定哦", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
              }).then(() => {
                this.form.customer_ids = [];
                this.form.customer_ids.push(customer.id);
                this.handleUnbind(customer);

              }).catch(() => {});
            },

          //解绑客户
          handleUnbind(customer) {
            CustomerService.unbind({'customer_ids':this.form.customer_ids}).then(res => {
              let form = this.form;
              // 只有成功时才显示消息和执行回调，错误消息已经由 axios 拦截器处理
              if (res.code == 0) {
                this.$message({
                  message: '解绑成功',
                  type: 'success'
                });
                form.customer_ids.map(function(customer_id, index){
                  if (customer.id == customer_id) {
                    customer.user_id = 0;
                    customer.username = '';
                  }
                });
              }
            });
          },


          /**
           * 处理绑定逻辑
           * Simon: 产品提出新需求要求绑定只可绑定给自己
           * @param customer
           */
          bindingUpdate(customer) {
            this.$confirm("确定要绑定该客户吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true
            }).then(() => {
              let userId = this.$store.getters.userId;
              if (userId > 0)  {
                this.form.user_id = userId;
              }
              this.form.customer_ids = [customer.id];

              CustomerService.bind(this.form).then(res => {
                if (res.code == 0) {
                  this.resp_alert(res, '领取成功', res => {
                    customer.username = res.data['username'];
                  })
                }
              });
            }).catch(() => {});
          },

            // 重载刷新客户信息
            refresh(state) {
                if (state == true) {
                    this.getInfo();
                }
            }
        },
        mounted() {
            this.$nextTick(function () {

            });
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

    .el-form-item__content > a {
        color: #1890ff;
    }

    .el-form-item__content > a:hover {
        color: #4ba9ff;
    }
</style>




// WEBPACK FOOTER //
// src/views/customer/view.vue